const fileDownloadButtonFormService = {
  title: 'Download Report'
};

export default fileDownloadButtonFormService;
